import { LegacyCustomer } from '../../../../../../../interfaces/api/Customer';
import React, { FC } from 'react';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { HeadCell, Order } from '../../../../../../../interfaces/Table';
import { createUseStyles } from '../../../../../../../theming';

interface Props {
  order: Order;
  orderBy: keyof LegacyCustomer;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof LegacyCustomer) => void;
  headCells: HeadCell<LegacyCustomer>[];
}

const useStyles = createUseStyles({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
});

const CustomersTableHead: FC<Props> = (props) => {
  const { order, orderBy, headCells, onRequestSort } = props;
  const classes = useStyles();

  const createSortHandler = (property: keyof LegacyCustomer) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sort ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomersTableHead;
